<template>
  <body class="hold-transition login-page">
  <div class="login-box" style="margin: 13% auto; width: 400px !important;">
    <div class="login-logo">
      <img src="/static/img/crp-images/Logo_RCP_Smart_App.png" class="logo-login-signup">
    </div>
    <!-- /.login-logo -->
    <div class="box login-bbox">
      <div class="box-body login-card-body pd-20">
        <p class="login-box-msg login-txt">
          <router-link class="left-side-arrow" to="/user/login">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </router-link>
          Forgotten Password
        </p>
        <p class="para-reset">Enter your email address below and we’ll email you a link for resetting your password.</p>
        <md-field :class="getValidationClass('email')">
          <label>Email</label>
          <md-input name="email" id="email" v-model="form.email"/>
          <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
          <span class="md-error" v-if="$v.form.email.required && this.backendValidationForm.email.isError">{{this.backendValidationForm.email.errorMsg}}</span>
        </md-field>
        <md-card-actions class="lg-sp">
          <md-button class="rgbtnn md-raised md-accent login-btn btn-block" @click="validateSubmission">Send</md-button>
        </md-card-actions>
      </div>
    </div>
  </div>
  </body>
</template>
<script>
  import api from '../../../api'
import $ from 'jquery'
import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'

var SyncLoader = require('vue-spinner/src/SyncLoader')

export default {
    name: 'UserForgotPasswordView',
    components: {
      'SyncLoader': SyncLoader
    },
    mixins: [validationMixin],
    data: () => ({
      form: {
        email: null
      },
      backendValidationForm: {
        email: {
          isError: false,
          errorMsg: ''
        }
      }
    }),
    validations: {
      form: {
        email: {
          required
        }
      }
    },
    methods: {
      clearNewForm() {
        this.$v.$reset()
        this.form.email = ''
      },
      validateSubmission() {
        this.$v.form.$touch()
        if (!this.$v.form.$invalid) {
          this.addNewRecord(this.$v.form.$model)
        }
      },
      addNewRecord(data) {
        var ref = this
        api.request('post', '/customer/forgottenpassword/web', data)
          .then(response => {
            if (response.status === 200) {
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.backendValidationForm.hasOwnProperty(key.toString())) {
                    ref.backendValidationForm[key.toString()].isError = true
                    ref.backendValidationForm[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                  }
                })
              } else if (response.data.result.status === 'success') {
                // eslint-disable-next-line no-undef
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: response.data.result.status.message || 'Email has send successfully.check your email address',
                  showConfirmButton: false,
                  timer: 2000
                })
                this.clearNewForm()
              }
            } else if (response.data.result.status === 'error') {
              this.newModalLoading = false
              this.newModal = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: response.data.result.message})
            } else {
              this.newModalLoading = false
              this.newModal = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
            // console.log(response)
            // if (response.hasOwnProperty('result') && response.result.hasOwnProperty('status') && response.status.status === 'success') {
            //   this.newModalLoading = false
            //   // this.form = response.data.result
            //   this.newModal = false
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'success', title: 'Record successfully saved'})
            //   // eslint-disable-next-line no-undef
            //   Swal.fire({
            //     position: 'center',
            //     icon: 'success',
            //     title: response.result.status.message || 'You have registered successfully',
            //     showConfirmButton: false,
            //     timer: 2000
            //   })
            //   this.clearNewForm()
            // } else if (response.hasOwnProperty('error') && response.error.hasOwnProperty('error') && response.error.error === 'error') {
            //   // form errorsback end
            // } else {
            //   this.newModalLoading = false
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'error', title: 'Something wrong'})
            // }
          }).catch(error => {
            this.newModalLoading = false
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      }
    }
  }
</script>
<style>
.para-reset{
  text-align: center;
}
  /*.logo-login-signup {*/
  /*  max-width: 50% !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// UserForgotPasswordView.vue?0e58c948